/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/change-visualization_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart--bar_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-bar-horizontal_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-column-stacked_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-bar-stacked_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart--line_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-area_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-point_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-marimekko_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/tree-map_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-heat-map_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-packed-bubble_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-hierarchical-packed-bubble_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/table_24',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-waterfall_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-bullet_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart--bubble_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-crosstab_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-data-player_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/map_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-composite_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/list_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/earth--filled_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-network_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart--pie_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-radial_24',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart--scatter_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/spiral_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-summary_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-word-cloud_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/complex-calendar-heat-map_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-driver-analysis_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/complex-hierarchy-pie_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-sunburst_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-decision-tree_32',
	'../../../lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/chart-summary-kpi_32'
], (
	change_visualization_32,
	complex_column_chart_32,
	complex_bar_32,
	complex_column_chart_stacked_32,
	complex_bar_stacked_32,
	complex_line_32,
	complex_area_32,
	complex_point_32,
	complex_marimekko_32,
	complex_tree_map_32,
	complex_heat_map_32,
	complex_packed_bubble_32,
	complex_hierarchical_packed_bubble_32,
	complex_table_32,
	complex_waterfall_32,
	complex_bullet_32,
	complex_bubble_32,
	complex_crosstab_32,
	complex_data_player_32,
	complex_map_legacy_32,
	complex_combo_32,
	complex_hierarchy_32,
	complex_map_chart_32,
	complex_network_32,
	complex_pie_32,
	complex_radial_32,
	complex_scatter_32,
	complex_spiral_driver_32,
	complex_summary_32,
	complex_word_cloud_32,
	complex_calendar_heat_map_32,
	complex_driver_analysis_32,
	complex_hierarchy_pie_32,
	complex_tree_sunburst_32,
	decision_tree_32,
	complex_kpi_summary_32
) => {

	/*
	* The following allows us to map a vis id to the graphic resources.
	*/
	return {
		graphicsMap: () => {
			return {
				'auto' : change_visualization_32,
				'com.ibm.vis.rave2bundlecolumn' : complex_column_chart_32,
				'com.ibm.vis.rave2bundlebar': complex_bar_32,
				'com.ibm.vis.rave2bundlestackedcolumn': complex_column_chart_stacked_32,
				'com.ibm.vis.rave2bundlestackedbar': complex_bar_stacked_32,
				'com.ibm.vis.rave2line': complex_line_32,
				'com.ibm.vis.rave2bundlearea': complex_area_32,
				'com.ibm.vis.rave2point': complex_point_32,
				'com.ibm.vis.rave2marimekko': complex_marimekko_32,
				'com.ibm.vis.rave2bundletreemap': complex_tree_map_32,
				'com.ibm.vis.rave2heat': complex_heat_map_32,
				'com.ibm.vis.rave2bundlepackedbubble': complex_packed_bubble_32,
				'com.ibm.vis.rave2bundlehierarchicalpackedbubble': complex_hierarchical_packed_bubble_32,
				'JQGrid': complex_table_32,
				'com.ibm.vis.rave2bundlewaterfall': complex_waterfall_32,
				'com.ibm.vis.rave2bundlebullet': complex_bullet_32,
				'com.ibm.vis.ravebubble': complex_bubble_32,
				'crosstab': complex_crosstab_32,
				'dataPlayer': complex_data_player_32,
				'com.ibm.vis.rave2polygonmap': complex_map_legacy_32,
				// 'com.ibm.vis.rave2bundlecomposite': complex_combo_32,
				'com.ibm.vis.rave2bundlecomposite': complex_combo_32,
				'list': complex_hierarchy_32,
				'com.ibm.vis.rave2bundletiledmap': complex_map_chart_32,
				'com.ibm.vis.rave2network': complex_network_32,
				'com.ibm.vis.rave2bundlepie': complex_pie_32,
				'com.ibm.vis.rave2bundleradialbar': complex_radial_32,
				'com.ibm.vis.ravescatter': complex_scatter_32,
				'com.ibm.vis.spiral': complex_spiral_driver_32,
				'kpi': complex_kpi_summary_32,
				'summary': complex_summary_32,
				'com.ibm.vis.rave2bundlewordcloud': complex_word_cloud_32,
				'com.ibm.vis.rave2calendarheatmap': complex_calendar_heat_map_32,
				'com.ibm.vis.rave2comet': complex_driver_analysis_32,
				'com.ibm.vis.rave2hierarchicalpie': complex_hierarchy_pie_32,
				'com.ibm.vis.sunburst': complex_tree_sunburst_32,
				'com.ibm.vis.decisiontree': decision_tree_32
			};
		}
	};
});
